import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { EmpdContext } from '../../Context';
import { useMsal } from '@azure/msal-react';
import UserData from '../../Interfaces/UserData'
import { globe, researchDocs } from "../../Assets/Images";
import CardGrid from "../../Components/CardGrid";
import FiftyFiftySection from "../../Components/FiftyFitySection";
import Hero from "../../Components/Hero";
import Messaging from "../../Components/Messaging";
import { WELCOME_PAGE_CONTENT } from "../../Consts/siteVerbiage";
import useScreenScroll from "../../Hooks/useScreenScroll";
import { RotatingLines } from 'react-loader-spinner';

interface WelcomeAnnouncement {
	content: string;
	type: string;
	header: string|undefined;
	showMessage: boolean;
	date_created: Date;
}

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const Welcome = () => {
  const { isLoading, fetchNamespace, fetchMessageContent, messagingContent, setAuthErrorDialogOpen } = useMyContext()
  const { instance } = useMsal();
  const navigate = useNavigate();
  let welcomeAnnouncement: WelcomeAnnouncement|undefined = undefined

  useEffect(() => {
  	fetchMessageContent()
  //	fetchNamespace()
  },[])

  useScreenScroll();

  if( messagingContent && messagingContent.length > 0 ) {
  	welcomeAnnouncement = messagingContent.find((element:any) => {
		return Object.keys(element)[0] === 'welcome_announcement'
	})['welcome_announcement']
  }

  if( isLoading ) {
  	return (
		<div className='center'>
			<RotatingLines
				strokeColor="#152E54"
        	    strokeWidth="3"
            	animationDuration="1.0"
	            width="48"
    	        visible={true}
        	/>
		</div>
	)
  } else {
	  return (
    	<div>
	      <Hero
    	    header={WELCOME_PAGE_CONTENT.HERO_TITLE}
        	description={WELCOME_PAGE_CONTENT.HERO_DESCRIPTION}
	        backgroundImage={researchDocs}
    	    coverImage={globe}
        	buttonLabel="Learn More About The Initiative"
	        buttonOnClick={() => navigate("behind-the-initiative")}
    	  />
		  {welcomeAnnouncement && welcomeAnnouncement.showMessage === true && (
		  	<Messaging
				header={welcomeAnnouncement.header}
		        backgroundImage={researchDocs}
				description={welcomeAnnouncement.content}	
			/>
		  )}
	      <CardGrid
    	    id={WELCOME_PAGE_CONTENT.WHAT_IS_EMPD.ID}
        	header={WELCOME_PAGE_CONTENT.WHAT_IS_EMPD.TITLE}
	        description={WELCOME_PAGE_CONTENT.WHAT_IS_EMPD.DESCRIPTION}
    	    cards={WELCOME_PAGE_CONTENT.WHAT_IS_EMPD.CARDS}
        	buttonLabel={"Meet Our Leadership Team"}
	        buttonOnClick={() => navigate("leadership")}
    	  />
	      <FiftyFiftySection
    	    id={WELCOME_PAGE_CONTENT.CHALLENGES.ID}
	        left={WELCOME_PAGE_CONTENT.CHALLENGES.LEFT_CONTENT}
    	    right={WELCOME_PAGE_CONTENT.CHALLENGES.RIGHT_CONTENT}
	        variant="white"
    	  />
	      <CardGrid
    	    id={WELCOME_PAGE_CONTENT.OUR_VISION.ID}
        	textAlign="center"
	        header={WELCOME_PAGE_CONTENT.OUR_VISION.TITLE}
    	    description={WELCOME_PAGE_CONTENT.OUR_VISION.DESCRIPTION}
        	cards={WELCOME_PAGE_CONTENT.OUR_VISION.CARDS}
	        buttonLabel={"Sign In or Sign Up"}
	        buttonOnClick={() => navigate('../registered') }
     	 />
    	</div>
	  );
  }
};

export default Welcome;
